import { render } from "./TariffBlock.vue?vue&type=template&id=67eb49d0"
import script from "./TariffBlock.vue?vue&type=script&lang=js"
export * from "./TariffBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__